"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountrySelect = CountrySelect;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CaretIcon = _interopRequireDefault(require("../images/CaretIcon"));

var _countries = _interopRequireDefault(require("./countries"));

var _Select = require("./Select.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CountrySelect(_ref) {
  var placeholder = _ref.placeholder,
      showSelectedLabel = _ref.showSelectedLabel,
      showOptionLabel = _ref.showOptionLabel,
      customLabels = _ref.customLabels,
      onChange = _ref.onChange,
      countries = _ref.countries,
      options = _ref.options,
      defaultCountry = _ref.defaultCountry,
      flagWidth = _ref.flagWidth,
      rest = _objectWithoutProperties(_ref, ["placeholder", "showSelectedLabel", "showOptionLabel", "customLabels", "onChange", "countries", "options", "defaultCountry", "flagWidth"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openOptions = _useState2[0],
      setOpenOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var selectedFlag = (0, _react.useRef)(null);
  var caretRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setCountries();
    setSelected(defaultCountry);
    window.addEventListener('click', closeOptions);
    return function () {
      return window.removeEventListener('click', closeOptions);
    };
  }, []);

  function setCountries() {
    return countries && countries.filter(function (country) {
      return _countries["default"][country];
    });
  }

  function toggleOptions() {
    setOpenOptions(!openOptions);
  }

  function onSelect(countryCode) {
    setSelected(countryCode);
    setOpenOptions(false);
    onChange && onChange(countryCode);
  }

  function closeOptions(event) {
    if (event.target !== selectedFlag.current && event.target !== caretRef.current) {
      setOpenOptions(false);
    }
  }

  var lcSelected = selected ? "".concat(selected).toLowerCase() : '';
  return /*#__PURE__*/_react["default"].createElement(_Select.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_Select.FlagSelect, rest, /*#__PURE__*/_react["default"].createElement(_Select.SelectFlagOption, {
    "data-testid": "country-select",
    ref: selectedFlag,
    onClick: toggleOptions
  }, selected && /*#__PURE__*/_react["default"].createElement(_Select.CountryFlag, null, /*#__PURE__*/_react["default"].createElement(_Select.FlagImage, {
    src: "/flags/".concat(lcSelected, ".svg"),
    alt: selected,
    flagWidth: flagWidth
  }), showSelectedLabel && /*#__PURE__*/_react["default"].createElement(_Select.CountryLabel, null, customLabels[selected] || _countries["default"][selected])), /*#__PURE__*/_react["default"].createElement(_Select.ArrowDown, {
    onClick: toggleOptions,
    ref: caretRef
  }, /*#__PURE__*/_react["default"].createElement(_CaretIcon["default"], {
    onClick: toggleOptions
  }))), openOptions && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Select.FlagOptions, null, countries.map(function (countryCode) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        outline: 'none',
        cursor: 'pointer'
      },
      key: countryCode,
      onClick: function onClick() {
        return onSelect(countryCode);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Select.CountryFlag, null, /*#__PURE__*/_react["default"].createElement(_Select.FlagImage, {
      src: "/flags/".concat(countryCode.toLowerCase(), ".svg"),
      alt: countryCode,
      flagWidth: flagWidth
    }), showOptionLabel && /*#__PURE__*/_react["default"].createElement(_Select.CountryLabel, null, customLabels[countryCode] || _countries["default"][countryCode])));
  })))));
}

CountrySelect.defaultProps = {
  placeholder: 'Select a country',
  showSelectedLabel: true,
  showOptionLabel: true,
  alignOptions: 'right',
  customLabels: {}
};
CountrySelect.propTypes = {
  placeholder: _propTypes["default"].string,
  showSelectedLabel: _propTypes["default"].bool,
  showOptionLabel: _propTypes["default"].bool,
  customLabels: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  countries: _propTypes["default"].array.isRequired,
  defaultCountry: _propTypes["default"].string.isRequired
};
var _default = CountrySelect;
exports["default"] = _default;